import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { ApiService } from 'app/providers/api.service';

@Component({
  selector: 'ds-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
  loadingImage: any
  constructor(private _authService: AuthService, private apiSrvc: ApiService) { };
  ngOnInit(): void {
    this.getOriginDtails();
    // alert('In Loading');
    console.log('in Loading');
  }

  getOriginDtails(): void {
    // this.apiSrvc.getBannerDtls().then((bnr_dtls) => {
    //   if (bnr_dtls) {
    //     this.loadingImage = bnr_dtls['app_ldng_img_url_tx'];
    //   }
    // });
    this.loadingImage = ''
  }

}
